export default __webpack_public_path__ + "static/media/misc-books1-1920w.dc85280c.png";